var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalEarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#3498DB",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0027 28.0094C30.5299 28.0094 29.3361 28.9048 29.3361 30.0094C29.3361 31.1139 30.5299 32.0094 32.0027 32.0094C33.4754 32.0094 34.6694 32.9049 34.6694 34.0094C34.6694 35.1139 33.4754 36.0094 32.0027 36.0094M32.0027 28.0094C33.1638 28.0094 34.1515 28.5659 34.5175 29.3427M32.0027 28.0094V26.676M32.0027 36.0094C30.8415 36.0094 29.8538 35.4529 29.4878 34.6761M32.0027 36.0094V37.3427",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 19.3428C33.3334 19.3428 32.9119 19.3428 32 19.3428C26.0289 19.3428 23.0434 19.3428 21.1884 21.1978C19.3334 23.0528 19.3334 26.0383 19.3334 32.0095C19.3334 37.9805 19.3334 40.9661 21.1884 42.8212C23.0434 44.6761 26.0289 44.6761 32 44.6761C37.9711 44.6761 40.9567 44.6761 42.8118 42.8212C44.6667 40.9661 44.6667 37.9805 44.6667 32.0095C44.6667 31.0976 44.6667 30.6761 44.6667 30.6761",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.651 19.324L39.0833 24.8949M37.9844 20.0197L38.142 24.1416C38.142 25.1132 38.7221 25.7185 39.7788 25.7948L43.9441 25.9906",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEarning);
export default __webpack_public_path__ + "static/media/total-earning.8d68d17f612e2088770ebbe36ef039ae.svg";
export { ForwardRef as ReactComponent };